import Vuex from "vuex";
import state from "./state";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";
import organisationModule from "./organisationModule/index";
import assetModule from "./assetModule/index";
import loadingModule from "./loadingModule/index";
import fileUploads from "./fileUploadsModule/index";
import Account from "./accountsModule/index";
import Esop from "./esopModule/index";
import ApiClient from "./apiClientModule/index";
import TokenModule from "./tokenModule/index";
import Spv from "./spvModule/index";
import { fundingModule } from "./fundingModule";

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        organisationModule,
        assetModule,
        fileUploads,
        loadingModule,
        Account,
        Esop,
        TokenModule,
        ApiClient,
        Spv,
        fundingModule
    },
});